<div class="mt-4 w-10/12 mx-auto  p-8 grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1  gap-1">
  <div class="lg:col-span-1 md:col-span-1 col-span-1 flex flex-col">
    <div class="font-bold text-4xl text-primary ">
      FAQ
    </div>
    <div class="font-normal text-gray-400 text-md mt-2">
      Frequently asked questions descriptions
    </div>
<!--    <img src="assets/mediaImages/policies-and-procedures-work.jpg" alt=""-->
<!--         class="mt-3 h-[150px] w-[150px] animate-bounce duration-500 self-baseline">-->
    <img src="assets/svg/undraw_thought_process_re_om58.svg" alt=""
         class="mt-6 h-[150px] w-[250px]  duration-2000 ease-linear self-baseline">


  </div>
  <div class="lg:col-span-4 md:col-span-3 col-span-1 pt-7">
    <mat-accordion displayMode="flat">
      <mat-expansion-panel
        hideToggle
        class="bg-white border-b {{ openedFaq === idx ? 'opened' : '' }}"
        (expandedChange)="changePanelState()"
        *ngFor="let faq of faqs$|async let idx = index">
        <mat-expansion-panel-header class="intro-y">
          <mat-panel-title>
            <div> {{ useEng ? faq.questionNameEn : faq?.questionName }}</div>
          </mat-panel-title>
          <div class="flex items-center justify-center py-1">
            <div class="rounded-full w-8 h-8  flex items-center justify-center border border-accent text-accent"
                 *ngIf="openedFaq !== idx; else opened">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </div>
            <ng-template #opened>
              <div class="rounded-full w-8 h-8  flex items-center justify-center border border-accent text-accent">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </div>
            </ng-template>
          </div>
        </mat-expansion-panel-header>
        <div class="text-justify text-gray-500 flex gap-2 px-6 pb-3">
          <span class="font-bold">{{ 'Answer' | concat | translate }}: </span>
          <div> {{ useEng ? faq.questionAnswerEn : faq?.questionAnswer }}</div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
